import classNames from 'classnames'
import {useEffect} from 'react'

import {subscribeOnBuild} from '../../../../../../../actions/builds'
import {useAppDispatch, useAppSelector} from '../../../../../../../hooks/react-redux'
import Routes, {getHref} from '../../../../../../../routes'
import {getBuild, getBuildStatusTypeFromBuild} from '../../../../../../../selectors'
import {formatBuildNumber} from '../../../../../../common/BuildNumber/BuildNumber.utils'
import RouterLink from '../../../../../../common/RouterLink/RouterLink'
import {usePipelineId} from '../../../../hooks/pipeline'
import {getBuildDuration, getBuildTimeInQueue} from '../PipelineNavigation.selectors'

import styles from './PipelineNavigationItem.css'

type Props = {
  runId: number
  maxDuration: number
  maxTimeInQueue: number
  active: boolean
}

const MAX_HEIGHT = 24

export function PipelineNavigationItem({runId, maxDuration, maxTimeInQueue, active}: Props) {
  const duration = useAppSelector(state => getBuildDuration(state, runId))
  const timeInQueue = useAppSelector(state => getBuildTimeInQueue(state, runId))
  const buildState = useAppSelector(state => getBuild(state, runId)?.state)
  const runStatusType = useAppSelector(state => getBuildStatusTypeFromBuild(getBuild(state, runId)))
  const title = useAppSelector(state => {
    const {number, queuePosition} = getBuild(state, runId) ?? {}
    return formatBuildNumber({number, isQueued: buildState === 'queued', queuePosition}).title
  })
  const id = usePipelineId()
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (buildState === 'running') {
      return dispatch(subscribeOnBuild(runId))
    }
    return undefined
  }, [buildState, dispatch, runId])

  return (
    <RouterLink
      to={getHref(Routes.PIPELINE_RUN, {id, runId: String(runId)})}
      className={classNames(styles.link, {[styles.active]: active})}
      title={title}
    >
      {buildState !== 'queued' && (
        <div
          className={classNames(styles.bar, styles[runStatusType], {
            [styles.running]: buildState === 'running',
          })}
          style={{height: MAX_HEIGHT * (duration / maxDuration)}}
        />
      )}
      <div
        className={styles.queued}
        style={{height: MAX_HEIGHT * (timeInQueue / maxTimeInQueue)}}
      />
    </RouterLink>
  )
}
